(() => {
    document.querySelectorAll('h2').forEach((h2) =>{
        h2.classList.add('headline-2');
    });

    document.querySelectorAll('h3').forEach((h3) =>{
        h3.classList.add('headline-3');
    });
})();
